import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import StadiaMaps from 'ol/source/StadiaMaps.js';
import { useGeographic } from 'ol/proj.js';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Style, Fill, Stroke } from 'ol/style';
import { toLonLat } from 'ol/proj.js';
import Overlay from 'ol/Overlay.js';
import { Attribution, defaults as defaultControls } from 'ol/control.js';
import * as olExtent from 'ol/extent';

// set up popup
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');

// set up overlay
const overlay = new Overlay({
	element: container,
	autoPan: {
		animation: {
			duration: 250,
		},
	},
});

// set up geojson url
const newStatesGeoUrl = '/cs-new-50-4326.json';

// set up projection
useGeographic();

// set up map
const usaExtent = [-125, 24, -66, 50];
const usaCenter = [-97, 40];

// set up state styles
const stateStyle1 = new Style({
	fill: new Fill({
		color: 'rgba(0, 200, 100, 0.66)',
	}),
	stroke: new Stroke({
		color: 'black',
		width: 0,
	}),
});
const stateStyle2 = new Style({
	fill: new Fill({
		color: 'rgba(0, 200, 200, 0.66)',
	}),
	stroke: new Stroke({
		color: 'black',
		width: 0,
	}),
});
const stateStyle3 = new Style({
	fill: new Fill({
		color: 'rgba(0, 100, 200, 0.66)',
	}),
	stroke: new Stroke({
		color: 'black',
		width: 1,
	}),
});
const stateStyle4 = new Style({
	fill: new Fill({
		color: 'rgba(0, 200, 0, 0.66)',
	}),
	stroke: new Stroke({
		color: 'black',
		width: 1,
	}),
});

// get state abbreviation from query string
const urlParams = new URLSearchParams(window.location.search);
const getStateQuery = urlParams.get('state');

// set up new states layer and extent
let newStatesLayer;
let newStatesExtent;
let initZoom = 4;
let allStates = false;

if ((getStateQuery) && (getStateQuery.length == 2)) {
	console.log('getStateQuery', getStateQuery);

	// get state query as uppercase
	const stateQueryAbbr = getStateQuery.toUpperCase();

	// get geojson data
	async function getData(url) {
		const response = await fetch(url);
		return response.json();
	}
	const geoJSONOut = await getData(newStatesGeoUrl);
	//console.log('geoJSONOut', geoJSONOut);

	// check if state feature exists in geojson
	const stateExists = geoJSONOut.features.some((feature) => feature.properties.state_abbr === stateQueryAbbr);
	//console.log('stateExists', stateExists);

	// get color query from query string as hex without hash
	const getColorQuery = urlParams.get('color');
	// console.log('getColorQuery', getColorQuery);

	// check if valid hex color (does not include hash)
	const validHexColor = /^([A-Fa-f0-9]{6})$/.test(getColorQuery);
	// console.log('validHexColor', validHexColor);

	// set state color default
	let stateColor = 'rgba(0, 100, 200, 0.66)';

	// set state color if valid hex color
	if (validHexColor) {
		// convert hex to rgba
		const hexToRgb = (hex) =>
			'rgba(' +
			parseInt(hex.substring(0, 2), 16) +
			', ' +
			parseInt(hex.substring(2, 4), 16) +
			', ' +
			parseInt(hex.substring(4, 6), 16) +
			', 0.66)';
		stateColor = hexToRgb(getColorQuery);
		// console.log('stateColor', stateColor);
	}

	if (stateExists) {

		// get state feature from geojson
		const stateFeature = geoJSONOut.features.find((feature) => feature.properties.state_abbr === stateQueryAbbr);
		//console.log('stateFeature', stateFeature);

		// create new vector source with state feature
		let newStateQuerySource = new VectorSource({
			features: new GeoJSON().readFeatures(stateFeature),
		});

		const newStateQueryStyle = new Style({
			fill: new Fill({
				color: stateColor,
			}),
			stroke: new Stroke({
				color: 'black',
				width: 1,
			}),
		});

		// create new vector layer with state source
		newStatesLayer = new VectorLayer({
			source: newStateQuerySource,
			style: newStateQueryStyle,
		});

		// get extent of state
		const stateExtent = newStateQuerySource.getExtent();

		// set new extent to state extent
		newStatesExtent = stateExtent;
		//console.log('newStatesExtent', newStatesExtent);

		// set new zoom to 10
		initZoom = 10;

	}
	else {
	 	// if state query does not exist, show all states
		allStates = true;
	}	
}
else {
	// if no state query, show all states
	allStates = true;
}

if (allStates) {

	// set up states layer
	newStatesLayer = new VectorLayer({
		source: new VectorSource({
			format: new GeoJSON(),
			url: newStatesGeoUrl,
		}),
		style: function (feature, resolution) {
			const ColorLabel = feature.get('color_labe');
			//console.log('ColorLabel', ColorLabel);

			// set up state style
			if (ColorLabel == '1') {
				return stateStyle1;
			} else if (ColorLabel == '2') {
				return stateStyle2;
			} else if (ColorLabel == '3') {
				return stateStyle3;
			} else {
				return stateStyle4;
			}
		},
	});

	// get extent of all states
	newStatesExtent = usaExtent
	//console.log('newStatesExtent', newStatesExtent);
}

// set up map
const map = new Map({
	target: 'map',
	layers: [
		new TileLayer({
			source: new OSM(),
		}),
		// new TileLayer({
		// 	source: new StadiaMaps({
		// 		//layer: 'stamen_watercolor',
		// 		layer: 'stamen_toner',
		// 	}),
		// }),
		newStatesLayer,
	],
	controls: defaultControls({ attribution: false }),
	overlays: [overlay],
	view: new View({
		center: olExtent.getCenter(newStatesExtent),
		zoom: initZoom,
	}),
});

// after map is loaded, wait 0.5 seconds, then zoom to usa extent
setTimeout(function () {
	map.getView().fit(newStatesExtent, {
		padding: [10, 10, 10, 10],
		duration: 1200,
	});
}, 500);

// "type": "Feature", "properties": { "state_name": "Hampton Roads", "state_abbr": "HR", "state_type": "N", 
//"color_labe": "3", "pop_2020": 1677321.0, "pop_2010": 1595242.0, "pop_2000": 1507971.0, "pop_1990": 1392495.0, 
//"counties_l": "James City,York,Isle of Wight,Newport News,Norfolk,Suffolk,Portsmouth,Poquoson,Hampton,Chesapeake,Williamsburg,Virginia Beach",
// "num_counti": 12.0, "state_orig": "VA", "urban_scor": 1.0, "land_area": 4600722420.0, "water_area": 1928067726.0, "votes_tota": 812483.0, "votes_diff": -137609.0, "votes_perc": -0.16936846678638201, "votes_dem": 466632.0 }, "geom

// set up click event
map.on('singleclick', function (evt) {

	// get coordinate and pixel
	const coordinate = evt.coordinate;
	const pixel = evt.pixel;
	// console.log('coordinate', coordinate);
	// console.log('pixel', pixel);

	// get feature at clicked coordinate
	newStatesLayer.getFeatures(pixel).then(function (features) {
		const feature = features.length ? features[0] : undefined;

		if (features.length) {
			// get extent of state
			const stateExtent = feature.getGeometry().getExtent();
			//console.log('stateExtent', stateExtent);

			// zoom to state extent
			map.getView().fit(stateExtent, {
				padding: [100, 100, 100, 100],
				duration: 1000,
			});

			// get state info
			let stateName = feature.get('state_name');
			let stateUSPS = feature.get('state_abbr');
			let statePop = feature.get('pop_2020');
			let stateCounties = feature.get('counties_l').replaceAll(',', ', ');
			let statePopRound = Math.round(statePop);
			let statePopString = statePopRound.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			let stateLink = 'www.citystates.us/' + stateName.replaceAll(' ', '-').toLowerCase();
			let stateUrl = 'https://' + stateLink;

			let stateLandArea = feature.get('land_area'); // in square meters
			let stateLandAreaSqMi = Math.round(stateLandArea * 0.000000386102159)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			let stateWaterArea = feature.get('water_area'); // in square meters
			let stateWaterAreaSqMi = Math.round(stateWaterArea * 0.000000386102159)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			// console.log('stateLink', stateLink);
			// console.log('stateLandAreaSqMi', stateLandAreaSqMi);
			// console.log('stateWaterAreaSqMi', stateWaterAreaSqMi);

			// set up popup content
			content.innerHTML =
				'<h2><a href="' +
				stateUrl +
				'" target="_parent">' +
				stateName +
				'</a></h2><p><b>Population: </b>' +
				statePopString +
				'<br><b>Land Area: </b>' +
				stateLandAreaSqMi +
				' sq mi' +
				'<br><b>Water Area: </b>' +
				stateWaterAreaSqMi +
				' sq mi' +
				'<br><br><b>Abbreviation: </b>' +
				stateUSPS +
				'<br><b>Counties: </b>' +
				stateCounties +
				'</p><a href="' +
				stateUrl +
				'" target="_parent">' +
				stateLink +
				'</a>';

			// set up popup position
			overlay.setPosition(coordinate);
		} else {
			// if no feature, close popup
			overlay.setPosition(undefined);
			closer.blur();

			return false;
		}
	});
});

// set up close popup event
closer.onclick = function () {
	// close popup
	overlay.setPosition(undefined);
	closer.blur();

	if (allStates) {
		// zoom to usa extent
		map.getView().fit(usaExtent, {
			padding: [10, 10, 10, 10],
			duration: 1200,
		});
	}

	return false;
};
